import React, { useEffect, useState } from 'react';
import { IconMoon, IconSun } from '../Icons';

function getDefaultTheme() {
  const savedTheme = typeof window !== 'undefined' && window.localStorage.getItem('theme');
  return savedTheme ? savedTheme : 'light';
}

export default function DarkTheme() {
  const [isDark, setIsDark] = useState(getDefaultTheme());

  useEffect(() => {
    if (isDark === 'dark') {
      document.body.classList.add('dark');
      document.body.classList.remove('light');
    } else {
      document.body.classList.remove('dark');
      document.body.classList.add('light');
    }
    window.localStorage.setItem('theme', isDark);
    getDefaultTheme();
  }, [isDark]);

  return (
    <div className="dark-mode" onClick={() => setIsDark(isDark === 'dark' ? 'light' : 'dark')}>
      <span className="dark-mode__icon">{isDark === 'dark' ? <IconMoon /> : <IconSun />}</span>
    </div>
  );
}
